<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <el-menu :router="true">
        <!-- <el-menu-item index="/me/overview">
          <i class="nc-icon nc-chart"></i>
          <span>Dashboard</span>
        </el-menu-item> -->
        <el-menu-item index="/me/cause/list">
          <i class="nc-icon nc-sun-fog-29"></i>
          <span>Causes</span>
        </el-menu-item>
        <el-submenu index="1">
          <template slot="title">
            <i class="nc-icon nc-money-coins"></i>
            <span>Finance</span>
          </template>
          <!-- <el-menu-item-group title="Import"> -->
          <!-- <el-menu-item index="/me/finance/donations">Donations</el-menu-item> -->
          <el-menu-item index="/me/finance/payment/list">Payments</el-menu-item>
          <el-menu-item index="/me/finance/recurring/list">Recurring Payments</el-menu-item>
          <el-menu-item index="/me/finance/balance/list">Balances</el-menu-item>
          <el-menu-item index="/me/finance/payout/list">Payouts</el-menu-item>
          <!-- </el-menu-item-group> -->
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">
            <i class="nc-icon nc-cogwheel"></i>
            <span>Settings</span>
          </template>
          <!-- <el-menu-item-group title="Import"> -->
          <!-- <el-menu-item index="/me/finance/donations">Donations</el-menu-item> -->
          <el-menu-item index="/me/settings/organization">Organization</el-menu-item>
          <el-menu-item index="/me/settings/bank/list">Bank Accounts</el-menu-item>
          <el-menu-item index="/me/settings/verify">Verification</el-menu-item>
          <!-- </el-menu-item-group> -->
        </el-submenu>
        <el-submenu index="3" v-if="hasAdmin">
          <template slot="title">
            <i class="nc-icon nc-ruler-pencil"></i>
            <span>Admin</span>
          </template>
          <el-menu-item index="/me/admin/balance/list">Balances</el-menu-item>
          <el-menu-item index="/me/admin/transfer/list">Bank Transfers</el-menu-item>
          <el-menu-item index="/me/admin/payout/list">Payouts</el-menu-item>
          <el-menu-item index="/me/admin/banner/list">Banners</el-menu-item>
          <el-menu-item index="/me/admin/exchangerate/list">Exchange Rates</el-menu-item>
          <el-menu-item index="/me/admin/organization/list">Organizations</el-menu-item>
          <el-menu-item index="/me/admin/user/list">Users</el-menu-item>
        </el-submenu>
      </el-menu>

      <template slot="bottom-links">
        <!-- <sidebar-link class="active"
                      to="/me/promotions">
          <i class="nc-icon nc-alien-33"></i>
          <p>Promotions</p>
        </sidebar-link> -->
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
import { computed, watch } from '@vue/composition-api'
import { What, Verb, can }  from '@/rights/rights.js'
import TopNavbar from './TopNavbar.vue'
import ContentFooter from './ContentFooter.vue'
import DashboardContent from './Content.vue'
import MobileMenu from './MobileMenu.vue'

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  setup(props, context) {
    const store = context.root.$store
    const hasAdmin = computed(() => {
      return can(Verb.VIEW, What.ADMIN, { roles: store.state.users.profile.roles })
    })
    store.dispatch('userGetProfile')
    return {
      hasAdmin
    }
  },
  methods: {
    toggleSidebar () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    }
  }
}

</script>
